<template>
  <div :id="id" />
</template>

<script>

export default {
  name: 'dynamic-script',
  props: {
    id: {
      type: String,
    },
    scriptSrc: {
      type: String,
      required: true
    },
  },
  mounted() {
    this.loadScript()
  },
  beforeUnmount() {
    if (this.scriptElement) {
      document.body.removeChild(this.scriptElement)
    }
  },
  methods: {
    loadScript() {
      this.scriptElement = document.createElement('script')
      this.scriptElement.src = this.scriptSrc
      this.scriptElement.async = true
      document.body.appendChild(this.scriptElement)
    },
  }
}
</script>
